











import VueStrong from '@/vueStrong';
import { Component, Vue, Prop, ModelSync, Watch } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class VCheckbox extends VueStrong {
    @Prop({
        type: Boolean,
        default: false
    })
    readonly isDark!: boolean;

    @ModelSync('checked', 'input', { type: Boolean, default: false }) checkedValue!: boolean

    public isChecked = false;

    mounted():void {
        this.isChecked = this.checkedValue;   
    }

    @Watch('checkedValue')
    onPropChanged(val: boolean):void {
        this.isChecked = val;
    }

    invert(): void {
        this.isChecked = !this.isChecked;
        this.checkedValue = this.isChecked;
    }
}
